<app-modal-dialog title="XPath helper" (dismiss)="cancel()">

  <main>
    @if (documentTypeId()) {
      @if (sampleData()) {
        @if (sampleIsUploaded()) {
          <app-textbox caption="Viewing uploaded document of type" [value]="documentTypeDisplay()" [readonly]="true">
          </app-textbox>
        }
        @else {
          <app-textbox caption="Viewing the latest document of type" [value]="documentTypeDisplay()" [readonly]="true">
          </app-textbox>
        }
        <app-textbox caption="CDM file name" [value]="sampleData().fileName" [readonly]="true">
        </app-textbox>
      }
      @else {
        <p>No completed documents found for the selected document type.</p>
        <p>You can upload a CDM document manually.</p>
      }
    }
    @else {
      <p>Document type is not specified!</p>
      <p>You can upload a CDM document manually.</p>
    }

    <app-single-file-upload (fileSelected)="fileSelected($event)" [allowedFileExtensions]="['.xml']" [maxFileSize]="2*1024*1024"></app-single-file-upload>

    <hr />

    <app-tree-view [virtualModeEnabled]="true" dataStructure="plain" [dataSource]="dataSource()" [itemTemplate]="itemTemplate" height="38vh" (itemClick)="itemClick($event)">
      <ng-template #itemTemplate let-data>
        @switch (data.nodeType) {
          @case (1) {
            <span>{{data.name}}</span>
            @if (data.value) {
              <span>: </span>
              <span><em><strong>{{data.value}}</strong></em></span>
            }
            @if (data.hasItems) {
              <span> ({{data.itemCount}})</span>
            }
          }

          @case (2) {
            <div class="attribute">
              <span>&#64;{{data.name}}</span>
              @if (data.value) {
                <span>: </span>
                <span><em><strong>{{data.value}}</strong></em></span>
              }
            </div>
          }
        }
      </ng-template>
    </app-tree-view>

    <hr />

    <app-textbox #xpathText caption="XPath" [value]="xpath()" [readonly]="true"></app-textbox>
  </main>

  <footer>
    <div class="button-container">
      <app-button primary width="100%" [disabled]="!xpathText.value()" (buttonClick)="ok()">Ok</app-button>
      <app-button secondary width="100%" (buttonClick)="cancel()">Cancel</app-button>
    </div>
  </footer>

</app-modal-dialog>
